import { t } from '@/i18n/translator';

export const AddAssetCommand = (
  addAssetsMutation: any,
  removeAssetsMutation: any,
  albumId: string,
  assetIds: Array<string>,
) => {
  const apply = (): any => {
    return addAssetsMutation({ albumId: albumId, assetIds: assetIds, undoable: true });
  };

  const undo = (): void => {
    void removeAssetsMutation({ albumId: albumId, assetIds: assetIds });
  };

  const redo = (): void => {
    void apply();
  };

  return {
    apply,
    undo,
    redo,
    message: t('commands.addAssets', { count: assetIds.length }),
  };
};
